export const enum RoleType {
  AGENT = 'AGENT',
  SUP = 'SUP',
  ADMIN = 'ADMIN',
  EVAL = 'EVAL',
  CALIBRATOR = 'CALIBRATOR',
  AUTO_EVAL = 'AUTO_EVAL',
  TECHNICAL = 'TECHNICAL',
}

export interface RoleDTOV2 {
  code: string
  type: RoleType
  active: boolean
}

export type RoleDTOV1 = RoleDTOV2 & {
  name: string
}

export const roleAuthorityPrefix = 'ROLE_'
